import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import WalletSelector from '../../../../selectors/pages/main/balance';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useLocation} from 'react-router-dom';

const generateLink = (project, code, short=false) => {
    let bot = ``;
    if(project === "playtime") bot = `playtime_casino_bot`;
    if(project === "webstore") bot = `playtime_webstore_bot`;
    if(project === "casinos") bot = `online_casinos_bot`;

    let link = `${!short ? `https://` : ''}t.me/${bot}?start=${code}`;

    return short ? `${link.substr(0,10)}...${link.split('?')[1]}` : link;
    // return link;
}

export default () => {
    const {halloween} = useSelector(Selector),
          {wallet} = useSelector(WalletSelector),
          [copied, setCopied] = useState(false),
          location = useLocation();

    useEffect(() => {
        if(copied)
            window.copiedTimeout = setTimeout(() => {
                setCopied(false);
            }, 1000);
    }, [copied]);

    useEffect(() => {
        return () => clearTimeout(window.copiedTimeout);
    }, [location]);

    return (
            <div className="h-modal  animate__fadeInUp animate__animated animate__faster">
                <div className="h-header">
                    Invite your friends
                    <div className="close">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_166_9619)">
                                <path d="M0 14L14 0" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14 14L0 0" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_166_9619">
                                    <rect width="14" height="14" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div className="h-body">
                    Invite your friends using your referral link and get tickets with them!
                    <br />
                    <br />
                    To receive a ticket, you need to invite a new referral. When the amount of his deposits starts from $40, you will both receive a ticket!
                    <CopyToClipboard text={generateLink(wallet.project, halloween.code)} onCopy={e => {
                        setCopied(true);
                    }}>
                        <div className={`copy ${copied ? 'active' : ''}`}>
                            {generateLink(wallet.project, halloween.code, true)}
                            {
                                copied 
                                ? (
                                    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.80039 13C6.50039 13 6.30039 12.9 6.10039 12.7L1.20039 7.49997C0.800391 7.09997 0.800391 6.49997 1.20039 6.09997C1.60039 5.69997 2.20039 5.69997 2.60039 6.09997L6.70039 10.5L15.1004 1.29997C15.4004 0.899971 16.1004 0.79997 16.5004 1.09997C16.9004 1.39997 17.0004 2.09997 16.7004 2.49997L16.6004 2.59997L7.50039 12.6C7.40039 12.9 7.10039 13 6.80039 13Z" stroke="none"/>
                                    </svg>
                                )
                                : (
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.333 8.93341V10.9334C11.333 13.6001 10.2663 14.6667 7.59967 14.6667H5.06634C2.39967 14.6667 1.33301 13.6001 1.33301 10.9334V8.40008C1.33301 5.73341 2.39967 4.66675 5.06634 4.66675H7.06634" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.3331 8.93341H9.19974C7.59974 8.93341 7.06641 8.40008 7.06641 6.80008V4.66675L11.3331 8.93341Z" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.7334 1.33325H10.4001" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M4.66699 3.33325C4.66699 2.22659 5.56033 1.33325 6.66699 1.33325H8.41366" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M14.6663 5.33325V9.45992C14.6663 10.4933 13.8263 11.3333 12.793 11.3333" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M14.667 5.33325H12.667C11.167 5.33325 10.667 4.83325 10.667 3.33325V1.33325L14.667 5.33325Z" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                )
                            }
                        </div>
                    </CopyToClipboard>
                </div>
            </div>
    )
}